<!-- ════════════════════════════════════
     COMPLETE PROFILE MODAL (ONE-TIME POPUP FOR ADMIN, DISTRICT_ADMIN, TALUKA_ADMIN)
     ════════════════════════════════════ -->
<div class="profile-modal-backdrop" *ngIf="showModal" (click)="$event.stopPropagation()">
  <div class="profile-modal-card" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="pm-header">
      <div class="pm-header-left">
        <div class="pm-header-icon-wrap">
          <span class="pm-icon">👤</span>
        </div>
        <div class="pm-header-text">
          <h3 class="pm-title">प्रोफाइल माहिती भरा</h3>
          <p class="pm-subtitle">Profile Details (नाव आणि पद आवश्यक)</p>
        </div>
      </div>
      <!-- Close button is ONLY available if user has already updated profile -->
      <button 
        *ngIf="currentUser?.profileUpdated" 
        type="button" 
        class="pm-close-btn" 
        (click)="closeModal()" 
        title="बंद करा">✕</button>
    </div>

    <!-- Alert / Notice (Mandatory notice if profile not updated) -->
    <div class="pm-notice" *ngIf="!currentUser?.profileUpdated">
      <span class="pm-notice-icon">⚠️</span>
      <div class="pm-notice-text">
        <strong>माहिती भरणे अनिवार्य आहे:</strong> पुढील कार्यवाहीसाठी आपले पूर्ण नाव आणि पद नोंदवणे आवश्यक आहे. ही माहिती भरल्याशिवाय ही खिडकी बंद करता येणार नाही.
      </div>
    </div>

    <!-- Form -->
    <form (ngSubmit)="submitProfile()" #completeProfileForm="ngForm" class="pm-form">
      <div class="pm-form-group">
        <label class="pm-label">
          पूर्ण नाव (Full Name) <span class="required-star">*</span>
        </label>
        <div class="pm-input-wrap" [class.has-error]="profileErrors.fullName">
          <span class="pm-input-icon">✍️</span>
          <input 
            type="text" 
            name="fullName" 
            class="pm-input" 
            [(ngModel)]="profileForm.fullName" 
            placeholder="उदा. डॉ. राहुल पाटील / Rajesh Sharma" 
            (input)="profileErrors.fullName = ''"
            autocomplete="name" />
        </div>
        <div class="pm-error-msg" *ngIf="profileErrors.fullName">
          <span class="err-icon">⚠️</span> {{ profileErrors.fullName }}
        </div>
      </div>

      <div class="pm-form-group">
        <label class="pm-label">
          पद / हुद्दा (Designation) <span class="required-star">*</span>
        </label>
        <div class="pm-input-wrap" [class.has-error]="profileErrors.designation">
          <span class="pm-input-icon">💼</span>
          <input 
            type="text" 
            name="designation" 
            class="pm-input" 
            [(ngModel)]="profileForm.designation" 
            placeholder="उदा. जिल्हा पशुसंवर्धन अधिकारी / DDO / LDO" 
            (input)="profileErrors.designation = ''" />
        </div>
        <div class="pm-error-msg" *ngIf="profileErrors.designation">
          <span class="err-icon">⚠️</span> {{ profileErrors.designation }}
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="pm-footer">
        <button 
          *ngIf="currentUser?.profileUpdated" 
          type="button" 
          class="btn-cancel" 
          (click)="closeModal()">
          रद्द करा
        </button>
        <button 
          type="submit" 
          class="btn-submit" 
          [disabled]="isSubmitting">
          <span class="spinner-border spinner-border-sm me-2" *ngIf="isSubmitting" role="status" aria-hidden="true"></span>
          <span>{{ isSubmitting ? 'जतन करत आहे...' : 'माहिती जतन करा (Save & Continue)' }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
